import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";

const { carbon } = colorsPalettes;

export const CountriesAutocompleteContainer = styled.div`
    border-radius: 3px;
    .CountryFilter-dropdownButton {
        ${setFontVariant("listItem1")};
    }

    .DropdownButton--filtersBarDropdownButton {
        border-left: none;
    }
`;

export const StyledCountryFilterContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 9px;
    cursor: pointer;
`;

export const StyledHeader = styled.span`
    ${setFontVariant("subtitle1", carbon[300])};
    display: flex;
    gap: 5px;
`;
